export default __webpack_public_path__ + "img/365d676a6e730fc5e34690e8fddffc9a.png";